<template>
  <div id="bg">
    <div class="md-layout" id="bar">
      <div class="md-layout-item">
        <span class="txt-common">{{ nowDateTime }}</span>
      </div>
      <div class="md-layout-item">
        <div id="title" class="md-layout-item txt-shadow">小云实时大数据</div>
      </div>
      <div class="md-layout-item">

      </div>
    </div>

    <!--上部五列-->
    <div class="md-layout">
      <!--第1列-->
      <div class="md-layout-item gap-r-l">
        <div class="md-layout">
          <div class="md-layout-item content-panel">
            <div class="md-layout">
              <div class="md-layout-item">
                <div class="txt-common gap_line">语音导航请求总量</div>
                <div class="txt-shadow seven">
                  {{ growStatistics.nav_request_count }}
                </div>
              </div>
              <div class="md-layout-item">
                <div class="txt-common gap_line">收听音乐总时长</div>
                <div class="txt-shadow seven">
                  {{ growStatistics.music_listen_duration }}
                </div>
              </div>
            </div>

            <div class="md-layout panel-gap">
              <div class="md-layout-item">
                <div class="txt-common gap_line">语音播放器请求总量</div>
                <div class="txt-shadow seven">
                  {{ growStatistics.control_request_count }}
                </div>
              </div>
              <div class="md-layout-item">
                <div class="txt-common gap_line">AI训练语料条数</div>
                <div class="txt-shadow seven">
                  {{ growStatistics.ai_train_count }}
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div id="myNavChart" :style="{width: '420px', height: '240px'}"></div>
          </div>
        </div>

        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div id="myVoiceChart" :style="{width: '420px', height: '300px'}"></div>
          </div>
        </div>

      </div>

      <!--第2列-->
      <div class="md-layout-item gap-r-l">
        <div class="md-layout">
          <div class="md-layout-item content-panel">
            <div class="txt-common gap_line">使用总时长</div>
            <div class="txt-shadow seven">
              {{ growStatistics.drive_duration }}
            </div>
          </div>
        </div>
        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div class="txt-common gap_line">年度听歌时长/小时</div>
            <div class="txt-shadow seven">
              {{ growStatistics.drive_mileage }}
            </div>
          </div>
        </div>
        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div id="myTrafficChart" :style="{width: '420px', height: '560px'}"></div>
          </div>
        </div>
      </div>

      <!--第3列-->
      <div class="md-layout-item gap-r-l md-size-30">
        <div class="md-layout md-alignment-center">
          <p class="txt-common">总用户数/人</p>
        </div>
        <div class="md-layout md-alignment-center">
          <div class="txt-shadow seven" style="color: white;font-size: 30px;">
            {{ summaryStatistics.total_count }}
          </div>
        </div>
        <div class="md-layout panel-gap md-alignment-center">
          <img src="../assets/img/device_loc.png">
        </div>
      </div>

      <!--第4列-->
      <div class="md-layout-item gap-r-l">
        <div class="md-layout">
          <div class="md-layout-item content-panel">
            <div class="txt-common gap_line">AI训练语料总时长</div>
            <div class="txt-shadow seven">
              {{ growStatistics.ai_train_duration }}
            </div>
          </div>
        </div>

        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div class="txt-common gap_line">年度总语音数/条</div>
            <div class="txt-shadow seven">
              {{ growStatistics.voice_count }}
            </div>
          </div>
        </div>

        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div id="myCityChart" :style="{width: '420px', height: '560px'}"></div>
          </div>
        </div>
      </div>

      <!--第5列-->
      <div class="md-layout-item gap-r-l">
        <div class="md-layout">
          <div class="md-layout-item content-panel">
            <div class="md-layout">
              <div class="md-layout-item">
                <div class="txt-common gap_line">日活跃人数/人</div>
                <div class="txt-shadow seven">
                  {{ summaryStatistics.day_count }}
                </div>
              </div>
              <div class="md-layout-item">
                <div class="txt-common gap_line">月活跃人数/人</div>
                <div class="txt-shadow seven">
                  {{ summaryStatistics.month_count }}
                </div>
              </div>
            </div>

            <div class="md-layout panel-gap">
              <div class="md-layout-item">
                <div class="txt-common gap_line">男女比例</div>
                <div class="txt-shadow seven">
                  1：0.86
                </div>
              </div>
              <div class="md-layout-item">
                <div class="txt-common gap_line">合作品牌</div>
                <div class="txt-shadow seven">
                  {{ summaryStatistics.device_name_count }}
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div id="myUserChart" :style="{width: '420px', height: '320px'}"></div>
          </div>
        </div>
        <div class="md-layout panel-gap">
          <div class="md-layout-item content-panel">
            <div class="md-layout">
              <span class="txt-common">语音搜索热词</span>
              <TagBall :hot_words="staticStatistics.voice_data.hot_voice_words"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--底下四列-->
    <div id="buttom" class="md-layout">
      <div class="md-layout-item gap-t-r-b-l">
        <div class="md-layout content-panel">
          <div class="md-layout-item">
            <div class="md-layout">
              <p class="txt-common">最受欢迎歌曲TOP{{ staticStatistics.song_data.top_songs.length }}</p>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.song_data.top_songs.slice(0, staticStatistics.song_data.top_songs.length/2)"
                   v-bind:key="top.song.name">
                <SongCircle :index="index + 1" :title="top.song.name"
                            :cover="top.song.cover"/>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.song_data.top_songs.slice(staticStatistics.song_data.top_songs.length/2)"
                   v-bind:key="top.song.name">
                <SongCircle :index="index + 1 + parseInt(staticStatistics.song_data.top_songs.length/2)"
                            :title="top.song.name"
                            :cover="top.song.cover"/>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="md-layout-item gap-t-r-b-l">
        <div class="md-layout  content-panel">
          <div class="md-layout-item">
            <div class="md-layout">
              <p class="txt-common">最受欢迎歌手TOP{{ staticStatistics.song_data.top_singers.length }}</p>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.song_data.top_singers.slice(0, staticStatistics.song_data.top_singers.length/2)"
                   v-bind:key="top.name">
                <SongCircle :index="index + 1" :title="top.name"
                            :cover="top.avatar"/>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.song_data.top_singers.slice(staticStatistics.song_data.top_singers.length/2)"
                   v-bind:key="top.name">
                <SongCircle :index="index + 1 + parseInt(staticStatistics.song_data.top_singers.length/2)"
                            :title="top.name"
                            :cover="top.avatar"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md-layout-item gap-t-r-b-l">
        <div class="md-layout  content-panel">
          <div class="md-layout-item">
            <div class="md-layout">
              <p class="txt-common">爆款产品</p>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.product_data.fashion_products.slice(0, staticStatistics.product_data.fashion_products.length/2)"
                   v-bind:key="top.name">
                <ProductRectangle :index="index + 1" :title="top.name"
                                  :cover="top.cover"/>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.product_data.fashion_products.slice(staticStatistics.product_data.fashion_products.length/2)"
                   v-bind:key="top.name">
                <ProductRectangle :index="index + 1 + parseInt(staticStatistics.product_data.fashion_products.length/2)"
                                  :title="top.name"
                                  :cover="top.cover"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md-layout-item gap-t-r-b-l">
        <div class="md-layout  content-panel">
          <div class="md-layout-item">
            <div class="md-layout">
              <p class="txt-common">新品推荐</p>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.product_data.new_products.slice(0, staticStatistics.product_data.new_products.length/2)"
                   v-bind:key="top.name">
                <ProductRectangle :index="index + 1" :title="top.name"
                                  :cover="top.cover"/>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item"
                   v-for="(top, index) in staticStatistics.product_data.new_products.slice(staticStatistics.product_data.new_products.length/2)"
                   v-bind:key="top.name">
                <ProductRectangle :index="index + 1 + parseInt(staticStatistics.product_data.new_products.length/2)"
                                  :title="top.name"
                                  :cover="top.cover"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
  </div>
</template>

<script>
import TagBall from "@/components/visualization/TagBall";
import SongCircle from "@/components/visualization/SongCircle";
import ProductRectangle from "@/components/visualization/ProductRectangle";

export default {
  name: "Main",
  components: {ProductRectangle, SongCircle, TagBall},
  data: () => ({
    dateTimeTimer: null,
    nowDateTime: '',
    growTimer: null,
    growStatistics: {
      nav_request_count: 0,
      music_listen_duration: 0,
      control_request_count: 0,
      ai_train_count: 0,
      drive_duration: 0,
      drive_mileage: 0,
      ai_train_duration: 0,
      voice_count: 0,
    },
    increasedStatistics: [],
    staticStatistics: {
      voice_data: {
        nav_destination_tendencies: [],
        voice_categories: [],
        hot_voice_words: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      },
      song_data: {
        top_songs: [],
        top_singers: [],
      },
      product_data: {
        fashion_products: [],
        new_products: [],
      }
    },
    cityStatistics: [],
    summaryStatistics: {
      total_count: 0,
      month_count: 0,
      day_count: 0,
      company_count: 0,//合作公司数目
      device_name_count: 0,//合作项目数目
    },
    toast: false,
    toastMsg: "",
  }),
  mounted() {
    this.loadSummaryStatistics();
    this.loadStatic();
    this.loadIncreased();
    this.showTrafficChart();
    this.loadCity();
    this.dateTimeTimer = setInterval(this.showNowDateTime, 1000);
    this.growTimer = setInterval(this.loadGrow, 5000);
  },
  methods: {
    showNowDateTime: function () {
      let dateTime = new Date();
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let day = dateTime.getDate();
      let week = dateTime.getDay();
      let weekArr = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      let hour = dateTime.getHours();
      let minute = dateTime.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      let second = dateTime.getSeconds();
      second = second < 10 ? "0" + second : second;
      this.nowDateTime = `${year}/${month}/${day} ${hour}:${minute}:${second} ${weekArr[week]}`;
    },
    loadSummaryStatistics: function () {
      this.$http.get('/api/statistics/user/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.summaryStatistics = data.data
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    loadIncreased: function () {
      this.$http.get('/api/statistics/day/increased/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.increasedStatistics = data.data.day_increased;
                this.showUserChart();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    loadGrow: function () {
      this.$http.get('/api/statistics/grow/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.growStatistics = data.data
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    loadStatic: function () {
      this.$http.get('/api/statistics/static/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.staticStatistics = data.data;
                this.showNavDestinationTendencies();
                this.showVoiceCategories();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    loadCity: function () {
      this.$http.get('/api/statistics/city/').then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.cityStatistics = data.data.locations;
                this.showCityChart();
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    showNavDestinationTendencies: function () {
      let myChart = this.$echarts.init(document.getElementById('myNavChart'), 'dark', {width: 420, height: 240});
      let nav = [];
      this.staticStatistics.voice_data.nav_destination_tendencies.forEach(item => {
        let t = {
          name: item.type,
          value: item.count,
        };
        nav.push(t);
      });
      myChart.setOption({
        backgroundColor: '',
        title: {
          text: '语音导航目的地趋势图',
          left: 'right'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
        },
        series: [{
          name: '销量',
          type: 'pie',
          radius: '50%',
          data: nav,
          emphasis: {
            itemStyle: {
              shadowBlur: 5,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      });
    },
    showVoiceCategories: function () {
      let myChart = this.$echarts.init(document.getElementById('myVoiceChart'), 'dark', {width: 420, height: 300});
      let xAxisData = [];
      let seriesData = [];
      this.staticStatistics.voice_data.voice_categories.forEach(item => {
        let x = item.type;
        xAxisData.push(x);
        let s = item.count;
        seriesData.push(s);
      });
      myChart.setOption({
            backgroundColor: '',
            title: {
              text: '语音使用场景排行（单位：万）',
              left: 'right'
            },
            xAxis: {
              type: 'category',
              data: xAxisData
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: seriesData,
                type: 'bar'
              }
            ]
          }
      );
    },
    showTrafficChart: function () {
      let myChart = this.$echarts.init(document.getElementById('myTrafficChart'), 'dark', {width: 420, height: 560});
      myChart.setOption({
            backgroundColor: '',
            title: {
              text: '用户年龄段'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '0%',
              right: '0%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: ['18岁以下', '18-24岁', '25-30岁', '31-35岁', '36-40岁', '41-59岁', '60岁以上']
            },
            series: [
              {
                name: '2022',
                type: 'bar',
                data: [0.30, 0.55, 1.58, 0.60, 1.80, 1.10, 1.15]
              }
            ]
          }
      );
    },
    showCityChart: function () {
      let myChart = this.$echarts.init(document.getElementById('myCityChart'), 'dark', {width: 420, height: 560});
      let xAxisData = [];
      let seriesData = [];
      this.cityStatistics.reverse().forEach(item => {
        let x = item.count;
        xAxisData.push(x);
        let s = item.city;
        seriesData.push(s);
      });
      myChart.setOption({
            backgroundColor: '',
            title: {
              text: '城市用户排名'
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '0%',
              right: '0%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: seriesData
            },
            series: [
              {
                name: '2021',
                type: 'bar',
                data: xAxisData
              }
            ]
          }
      );
    },
    showUserChart: function () {
      let myChart = this.$echarts.init(document.getElementById('myUserChart'), 'dark', {width: 420, height: 320});
      let xAxisData = [];
      let seriesData = [];
      this.increasedStatistics.forEach(item => {
        xAxisData.push(item.date);
        seriesData.push(item.total_count);
      });
      myChart.setOption({
            backgroundColor: '',
            title: {
              text: '用户增长趋势'
            },
            xAxis: {
              type: 'category',
              data: xAxisData
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: seriesData,
                type: 'line',
                smooth: true
              }
            ]
          }
      );
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  },
  beforeDestroy() {
    if (this.dateTimeTimer) {
      clearInterval(this.dateTimeTimer)
    }
    if (this.growTimer) {
      clearInterval(this.growTimer)
    }
  }
}
</script>

<style scoped>
#bar {
  padding: 100px 0 50px 0;
}

#title {
  font-size: 40px;
}

.txt-common {
  color: white;
  font-size: 20px;
}

.txt-shadow {
  color: white;
  text-shadow: 0 0 0px #fff, 0 0 5px #fff, 0 0 10px #fff, 0 0 35px #ff00de, 0 0 60px #ff00de;
}

#bg {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: #1D1D45;
  padding: 0 10px 0 10px;
}

.content-panel {
  padding: 20px 20px 20px 20px;
  background-color: #23305D;
  border: 1px solid #8d99cd;
  border-radius: 6px;
}

.seven {
  font-family: seven, monospace;
  color: white;
  font-size: 40px;
  padding: 20px 0 0 0
}

.gap-t-r-b-l {
  padding: 10px 10px 10px 10px;
}

.gap-r-l {
  padding: 0px 10px 0px 10px;
}

.panel-gap {
  padding: 20px 0 0 0;
}

.gap_line {
  padding: 20px 0 10px 0;
}

#buttom {
  padding: 50px 0 0 0;
}
</style>